import { trpc } from '@/lib/api/trpc';

/**
 * Hook to fetch billing reports list
 */
export function useBillingReports(enabled = true) {
  const {
    data: reportsData,
    refetch: refetchReports,
    isLoading: isLoadingReports
  } = trpc.billingReports.list.useQuery(
    {
      limit: 100,
      offset: 0
    },
    { enabled },
  );

  return {
    reports: reportsData?.reports || [],
    refetchReports,
    isLoadingReports
  };
}

/**
 * Hook to fetch billing report details
 */
export function useBillingReportDetails(reportId: string | null) {
  const {
    data: reportDetailsData,
    isLoading: isLoadingReportDetails
  } = trpc.billingReports.getDetails.useQuery(
    { reportId: reportId || '' },
    { enabled: !!reportId }
  );

  return {
    reportDetails: reportDetailsData,
    isLoadingReportDetails
  };
}

/**
 * Hook to fetch billing preview for current or custom period
 */
export function useBillingPreview(
  periodStart?: string,
  periodEnd?: string,
  enabled = true,
) {
  const {
    data: previewData,
    refetch: refetchPreview,
    isFetching: isFetchingPreview
  } = trpc.billingReports.previewCurrent.useQuery(
    {
      period: 'weekly',
      periodStart,
      periodEnd
    },
    { enabled },
  );

  return {
    preview: previewData?.preview,
    refetchPreview,
    isFetchingPreview
  };
}

/**
 * Hook to fetch account plan details
 */
export function useAccountPlan(enabled = true) {
  const {
    data: accountPlanData,
    refetch: refetchAccountPlan,
    isLoading: isLoadingAccountPlan
  } = trpc.accountPlans.get.useQuery(
    {
      planType: 'scale'
    },
    { enabled },
  );

  return {
    accountPlan: accountPlanData,
    refetchAccountPlan,
    isLoadingAccountPlan
  };
}

/**
 * Hook to fetch saved payment methods
 */
export function usePaymentMethods() {
  const {
    data: paymentMethodsData,
    isLoading: isLoadingPaymentMethods
  } = trpc.billing.listPaymentMethods.useQuery({});

  return {
    paymentMethods: paymentMethodsData?.methods || [],
    billingProvider: paymentMethodsData?.provider ?? null,
    isLoadingPaymentMethods
  };
}
